import { Routes } from '@angular/router';
import { PatientNavigationEnum } from '../../navigation.enum';
import { OrderComponent } from './order.component';
import { RehabilitationOrderComponent } from './rehabilitation/rehabilitation.component';
import { EducationOrderComponent } from './education/education.component';
import { ServiceOrderComponent } from './service/service.component';

export const orderRoutes: Routes = [
  {
    path: PatientNavigationEnum.order,
    component: OrderComponent,
    children: [
      {
        path: '',
        redirectTo: PatientNavigationEnum.order_list_rehabilitation,
        pathMatch: 'full',
      },
      {
        path: PatientNavigationEnum.order_list_rehabilitation,
        component: RehabilitationOrderComponent,
      },
      {
        path: PatientNavigationEnum.order_list_education,
        component: EducationOrderComponent,
      },
      {
        path: PatientNavigationEnum.order_list_service,
        component: ServiceOrderComponent,
      },
    ],
  },
];
